import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StoreState, VoucherState } from "types/state/StoreState";

import { CommonRequest } from "types/common";
import {
  createVoucherApi,
  getAllRewardsApi,
  getAllVouchersApi,
  updateVoucherApi
} from "services/api/voucherApi";
import { NewVoucher, Rewards, Voucher } from "types/Voucher";

const voucherSlice = createSlice({
  name: "voucher",
  initialState: {
    isLoading: false,
    vouchers: [],
    rewards: {} as Rewards
  } as VoucherState,
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setVoucher(state, action) {
      state.vouchers = action.payload;
    },
    setRewards(state, action) {
      state.rewards = action.payload;
    }
  }
});
// Thunk Actions
export const getVoucherThunk = createAsyncThunk(
  "voucher/getVoucherThunk",
  async (request: CommonRequest, thunkApi) => {
    const { dispatch } = thunkApi;
    const { accessToken, businessId } = request;
    dispatch(voucherSlice.actions.setIsLoading(true));
    const vouchers = await getAllVouchersApi(accessToken, businessId);
    dispatch(voucherSlice.actions.setVoucher(vouchers));
    dispatch(voucherSlice.actions.setIsLoading(false));
  }
);

type NewRequest = {
  accessToken: string;
  newVoucher: NewVoucher;
  businessId: string;
};
export const createVoucherThunk = createAsyncThunk(
  "voucher/createVoucherThunk",
  async (request: NewRequest, thunkApi) => {
    const { dispatch } = thunkApi;
    const { newVoucher, accessToken, businessId } = request;
    dispatch(voucherSlice.actions.setIsLoading(true));
    await createVoucherApi(newVoucher, accessToken, businessId);
    dispatch(voucherSlice.actions.setIsLoading(false));
  }
);

export const updateVoucherThunk = createAsyncThunk(
  "voucher/updateVoucherThunk",
  async (request: NewRequest, thunkApi) => {
    const { dispatch } = thunkApi;
    const { newVoucher, accessToken, businessId } = request;
    dispatch(voucherSlice.actions.setIsLoading(true));
    await updateVoucherApi(newVoucher, accessToken, businessId);
    dispatch(voucherSlice.actions.setIsLoading(false));
  }
);

export const getRewardsThunk = createAsyncThunk(
  "voucher/getRewardsThunk",
  async (request: CommonRequest, thunkApi) => {
    const { dispatch } = thunkApi;
    const { accessToken, businessId, page } = request;
    dispatch(voucherSlice.actions.setIsLoading(true));
    const vouchers = await getAllRewardsApi(accessToken, businessId, page);
    dispatch(voucherSlice.actions.setRewards(vouchers));
    dispatch(voucherSlice.actions.setIsLoading(false));
  }
);
// Reducers
export const getLoadingStatus = (state: StoreState): boolean =>
  state.voucher.isLoading;
export const getVouchers = (state: StoreState): Voucher[] =>
  state.voucher.vouchers;
export const getRewards = (sate: StoreState): Rewards => sate.voucher.rewards;
export default voucherSlice.reducer;
